import { ChatItem, ChatItemTypes, ChatTextItem } from './types';

export function isClientChatItem(item: ChatTextItem) {
  return item.data.source === 'client';
}

export const sanitizeChatItems = (body?: ChatItem | ChatItem[]) => {
  if (!body) return [];

  if (Array.isArray(body)) {
    return body;
  } else {
    return [body];
  }
};

export const filterInvalidChatItems = (
  body?: ChatItem | ChatItem[]
): ChatItem[] => {
  return sanitizeChatItems(body).filter(validateChatItem);
};

export const getCommandsFromChatItems = <T>(
  items: ChatItem | ChatItem[]
): T[] | undefined => {
  if (Array.isArray(items)) {
    return items.map((item) => item.commands || []).flat() as T[];
  } else {
    return items.commands as T[];
  }
};

export const removeEmptyTextItems = (items: ChatItem[]) => {
  return items.filter((item) => {
    if (item.type === ChatItemTypes.TEXT) {
      return !!item.data.text?.length;
    }
    return true;
  });
};

export const validateChatItem = (item: ChatItem): boolean => {
  switch (item.type) {
    case ChatItemTypes.TEXT:
      return !!(item.data.text && item.data.text.length > 0);
    default:
      return true;
  }
};

export function findFirstTextItem(items: ChatItem[]) {
  return items.find((item) => item.type === ChatItemTypes.TEXT) as
    | ChatTextItem
    | undefined;
}
